<!-- @format -->

<template>
	<Teleport to="body">
		<div
			v-if="consent.needsPrompt"
			class="cookie-consent-modal"
			role="dialog"
			aria-modal="false"
			aria-labelledby="cookie-consent-title"
			aria-describedby="cookie-consent-intro"
			@keydown.esc.stop="handleRejectAll"
		>
			<div
				ref="dialog"
				class="cookie-consent-modal__dialog"
				tabindex="-1"
			>
				<h2
					id="cookie-consent-title"
					class="cookie-consent-modal__title"
				>
					{{ $t('§consent.title') }}
				</h2>

				<p
					id="cookie-consent-intro"
					class="cookie-consent-modal__intro"
				>
					{{ $t('§consent.intro') }}
				</p>

				<div class="cookie-consent-modal__categories">
					<ConsentToggle
						:modelValue="true"
						:disabled="true"
						name="consent-necessary"
						label="§consent.category_necessary"
						description="§consent.category_necessary_description"
					/>
					<ConsentToggle
						v-model="localAnalytics"
						name="consent-analytics"
						label="§consent.category_analytics"
						description="§consent.category_analytics_description"
					/>
					<ConsentToggle
						v-model="localMarketing"
						name="consent-marketing"
						label="§consent.category_marketing"
						description="§consent.category_marketing_description"
					/>
				</div>

				<div class="cookie-consent-modal__actions">
					<CoreButton
						ref="acceptButton"
						variant="primary"
						:label="'§ui_button.accept_all'"
						@click="handleAcceptAll"
					/>
					<CoreButton
						variant="secondary"
						:label="'§ui_button.save_preferences'"
						@click="handleSavePreferences"
					/>
					<CoreButton
						ref="rejectButton"
						variant="tertiary"
						:label="'§ui_button.reject_all'"
						@click="handleRejectAll"
					/>
				</div>
			</div>
		</div>
	</Teleport>
</template>

<script>
import { useConsentStore } from '@/stores/consent'
import ConsentToggle from '@/components/ConsentToggle.vue'
import CoreButton from '@/components/core/CoreButton.vue'

export default {
	name: 'CookieConsentModal',

	components: { ConsentToggle, CoreButton },

	data() {
		return {
			consent: useConsentStore(),
			localAnalytics: false,
			localMarketing: false,
		}
	},

	watch: {
		'consent.needsPrompt': {
			immediate: true,
			handler(needsPrompt) {
				if (needsPrompt) {
					this.localAnalytics = this.consent.analytics
					this.localMarketing = this.consent.marketing
				}
			},
		},
	},

	methods: {
		handleAcceptAll() {
			this.consent.acceptAll()
		},

		handleRejectAll() {
			this.consent.rejectAll()
		},

		handleSavePreferences() {
			this.consent.save({
				analytics: this.localAnalytics,
				marketing: this.localMarketing,
			})
		},
	},
}
</script>

<style scoped>
.cookie-consent-modal {
	position: fixed;
	bottom: 16px;
	right: 16px;
	z-index: 10000;
	max-width: calc(100vw - 32px);
}

.cookie-consent-modal__dialog {
	width: 420px;
	max-width: 100%;
	max-height: calc(100vh - 32px);
	overflow-y: auto;
	padding: 28px 24px 20px;
	background-color: var(--color-white, #fff);
	border-radius: 12px;
	box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);
	border: 1px solid var(--color-neutral-200, #e5e5e5);
}

.cookie-consent-modal__dialog:focus {
	outline: none;
}

.cookie-consent-modal__title {
	margin: 0 0 12px;
	font-size: 2.2rem;
	font-weight: 700;
	line-height: 1.2;
	color: var(--text-dark, #040f0f);
}

.cookie-consent-modal__intro {
	margin: 0 0 20px;
	font-size: 1.6rem;
	line-height: 1.5;
	color: var(--color-secondary-500, #315957);
}

.cookie-consent-modal__categories {
	margin-bottom: 20px;
}

.cookie-consent-modal__actions {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.cookie-consent-modal__actions > * {
	width: 100%;
}

@media (max-width: 480px) {
	.cookie-consent-modal {
		bottom: 0;
		right: 0;
		left: 0;
		max-width: 100vw;
	}

	.cookie-consent-modal__dialog {
		width: 100%;
		border-radius: 12px 12px 0 0;
		border-bottom: none;
	}
}
</style>
